<script lang="ts" setup>
import Multiselect from 'vue-multiselect';

const selected = defineModel<string | number | object | null>();

const props = defineProps<{
  autoSelectOnInit?: boolean;
  fieldLabel?: string;
  required?: boolean;
  id?: string | number;
  label?: string;
  options: object[] | string[];
  placeholder?: string;
  searchable?: boolean;
  trackBy?: string;
  allowEmpty?: boolean;
}>();

onMounted(() => {
  if (props.autoSelectOnInit && props.options.length && !selected.value) {
    selected.value = props.options[0];
  }
});

const selectField = ref();
const { isMobile } = useBreakpoints();

const handleClick = () => {
  if (isMobile.value) {
    selectField.value.deactivate();
  }
};
</script>

<template>
  <div
    :class="{ selected: selected }"
    class="select-field__box"
  >
    <label
      v-if="fieldLabel"
      :for="String(id)"
      class="select-field__label"
    >
      {{ fieldLabel }}
      <span
        v-if="required"
        class="text-big error--text"
      >
        *
      </span>
    </label>

    <multiselect
      :id="String(id)"
      ref="selectField"
      v-model="selected"
      :allow-empty
      :clear-on-select="false"
      :label
      :options
      :placeholder
      :searchable
      :track-by
      class="mb-0"
      deselect-label=""
      select-label=""
      selected-label=""
      @open="handleClick"
    >
      <template #beforeList>
        <slot name="beforeList" />
      </template>

      <template #singleLabel="{ option }">
        <slot
          :option="option"
          name="singleLabel"
        />
      </template>

      <template #tag="{ option }">
        <slot
          :option="option"
          name="tag"
        />
      </template>

      <template #option="{ option }">
        <slot
          :option="option"
          name="option"
        />
      </template>

      <template #caret="{ toggle }">
        <slot
          :toggle="toggle"
          name="caret"
        />
      </template>

      <span slot="noResult"> Ничего не найдено </span>
    </multiselect>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.select-field {
  &__box {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  &__label {
    color: $black-80;
    font-size: $text-xs;
  }
}

.multiselect {
  &__tags {
    padding: 10px 40px 0 8px;
    border-radius: 8px;
    cursor: pointer;
    transition: border-color 0.2s;

    &:hover {
      border-color: $black-40;
    }

    &:focus {
      border-color: $black-80;
    }
  }

  &__content-wrapper {
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    transition: border-color 0.2s;

    .multiselect--above & {
      border-radius: 8px 8px 0 0;
    }
  }

  &__option {
    &--highlight {
      background-color: $black;
    }

    &--selected {
      background-color: $black-20;
    }

    &--selected.multiselect__option--highlight {
      background-color: $black-60;
    }

    &--disabled {
      background-color: $black-10 !important;
    }
  }
}

.selected .multiselect__tags {
  border-color: $black;
}
</style>
